<div class="ion-header ion-hide-lg-up j">
  <header-main></header-main>
  <div class="ion-fab">
    <div class="ion-fab-button close button-tertiary button-round">
      <a href="/how-it-works">
        <img class="ion-icon" src="assets/icons/close.svg">
      </a>
    </div>
  </div>
</div>

<main class="ion-content" fullscreen>
  <header class="ion-hide-lg-down j">
    <header-desktop></header-desktop>
    <h1 color="white">
      <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.73 27.93"><defs><style>.jobs{stroke:none;}</style></defs><title>jobs</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="jobs" d="M28.07,5.76H23.61V4.7A4.71,4.71,0,0,0,18.91,0H13.82a4.71,4.71,0,0,0-4.7,4.7v6.86a1,1,0,0,0,2,0V7.76H21.61v3.8a1,1,0,1,0,2,0V7.76h4.46a2.67,2.67,0,0,1,2.66,2.67V23.27a2.66,2.66,0,0,1-2.66,2.66H4.67A2.67,2.67,0,0,1,2,23.27V10.43A2.68,2.68,0,0,1,4.67,7.76a1,1,0,0,0,0-2A4.68,4.68,0,0,0,0,10.43V23.27a4.67,4.67,0,0,0,4.67,4.66h23.4a4.66,4.66,0,0,0,4.66-4.66V10.43A4.67,4.67,0,0,0,28.07,5.76Zm-17,0V4.7A2.7,2.7,0,0,1,13.82,2h5.09a2.7,2.7,0,0,1,2.7,2.7V5.76Z"></path></g></g></svg>
      How it works: Jobs
    </h1>
  </header>

  <div class="container-fluid details-wrapper">
    <div class="row">
      <div class="col col-xs-12 col-md-10 col-lg-8 col-xl-6 col-md-offset-1 col-lg-offset-2 col-xl-offset-3">
        <div class="details-content">
          <img class="ion-margin-bottom" src="assets/images/how-it-works/jobs.jpg" alt="Jobs">
          <div>
            <div class="description">
              <h1>gigexchange is the fastest growing job search platform.</h1>
              
              <p>Businesses are discovering our free jobsite daily and jobseekers are registering in greater numbers all the time.</p>

              <h2>Listing a job</h2>
              
              <p>We are different to other job listing sites because we offer reputation transparency. This rewards those who work hard to build an honest, professional personal brand, while also aiding businesses and recruiters in finding great talent that is the right fit for their business.</p>

              <p>This feature alone provides greater value than other job listing sites available. But it doesn’t stop there; we don’t charge extra for featured posts. Instead, this will be provided free in recognition of the reputation you build on the site. Our reputation system will also transcend to all services offered on our platform.</p>
              
              <p>We are also developing AI to help filter the perfect candidates for you freeing up your valuable recruitment or HR time. Watch this space.</p>

              <p>Job advertisements are listed for 30 days.</p>

              <h2>Job hunters</h2>
              
              <p>You can simply update your profile to include jobs skills/classifications (transferable across all services). The reputation you build on gigexchange can help you land a dream job or contract, or strengthen your brand when moving into the gig economy, or new business venture.</p>

              <p>We do not host CVs on the platform, we simply point all applications to the job listers URL to complete the application process. We do provide a private chat portal for feedback and reviews.</p>

              <p>We will be expanding our search selections soon.</p>

              <p>Get in touch if interested in bulk job uploads via our contact page.</p>
              
              <p>For more information on our categories &amp; classifications, check out our <a routerLink="/support">Help Centre</a> &amp; <a href="/faqs">FAQs</a>.</p>
              
              <h4>Find out <a routerLink="/support/job-lister/difference-between-gig-job">here</a> whats the difference between a gig and a job?</h4>
              
              <h4>Find out <a routerLink="/support/job-lister/difference-between-gig-contract">here</a> whats the difference between a gig and a contract?</h4>

              <h5>gigexchange. Empowering the jobs win</h5>
            </div>
          </div>
          <div class="details-author">
            <p>Posted by: gigexchange</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
